import React from 'react'
import styled from 'styled-components'
import { useDrag } from 'react-dnd'
import toast from 'react-hot-toast'
import { ItemTypes } from '../../../../constants'

function Image(props) {
  const ImageContainer = styled.div`
    margin-bottom: 10px;
    width: 100%;
    height: auto;
    display: block;
    position: relative;
  `

  const Image = styled.img`
    margin-bottom: 10px;
    width: 100%;
    height: auto;
    display: block;
  `

  const ImageOverlay = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    opacity: 0.7;
    background-color: black;
    display: flex;
    align-items: center;
    justify-content: center;
  `

  const ImageOverlayText = styled.div`
    font-family: Hind;
    font-size: 12px;
    color: white;
    text-transform: uppercase;
    letter-spacing: 1px;
  `

  const onDrop = (item, dropResult, additionalInfo, saveSubmission, createBoard) => {
    let info = additionalInfo
    const imageId = item.image.id
    const isLead = dropResult.placementObject === 'lead'
    const previousLead = info.leadImage

    if (isLead) info.leadImage = imageId
    else info.sections[dropResult.placementObject[0]].images[dropResult.placementObject[1]].images.push(imageId)
    saveSubmission(info)

    createBoard(imageId)
      .then(() => {
        toast.success('Image added to post')
      })
      .catch(() => {
        if (isLead) {
          info.leadImage = previousLead
        } else {
          const arr = info.sections[dropResult.placementObject[0]].images[dropResult.placementObject[1]].images
          const idx = arr.lastIndexOf(imageId)
          if (idx !== -1) arr.splice(idx, 1)
        }
        saveSubmission(info)
        toast.error(`Could not add image ${imageId} to the post. Please try again.`)
      })
  }

  const { isUsed, saveSubmission, createBoard, additionalInfo, image, src } = props

  const [{isDragging}, drag] = useDrag(() => ({
    type: ItemTypes.IMAGE,
    item: { image },
    end(item, monitor) {
      const dropResult = monitor.getDropResult()
      if (item && dropResult) {
        onDrop(item, dropResult, additionalInfo, saveSubmission, createBoard)
      }
    },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    })
  }), [image, saveSubmission, additionalInfo])

  return (
    <ImageContainer>
      <Image
        ref={drag}
        style={{ opacity: isDragging ? 0.2 : 1, cursor: isDragging ? 'move' : 'initial' }}
        src={src}
      />
      {isUsed && <ImageOverlay><ImageOverlayText>Used</ImageOverlayText></ImageOverlay>}
    </ImageContainer>
  )
}

export default Image


